import CachedObjectStore from 'bz-utilities/modules/stores/cached-object-store';
import { action } from 'mobx';
import type { SecurityResponse } from 'tm3-core/api.dtos';

class PermissionsStore extends CachedObjectStore<SecurityResponse> {
  get editableServiceTypeIds() {
    return this.all.editableServiceTypeIds;
  }
  get roleMap() {
    return this.all.roleMap;
  }
  get roles() {
    return this.all.roles;
  }
  hasRead: boolean = false;
  private map = new Map<string, any>();

  constructor() {
    super('permissions');
  }

  public reset(): void {
    this.map.clear(); // for logout
    this.atom.reportChanged();
  }

  public onRequestClear(): void {
    this.map.clear(); // for logout
    this.atom.reportChanged();
  }

  @action.bound
  canDoAction(action: string, locationId: number) {
    let rules = this.map.get((locationId || -1).toString());

    if (!rules) {
      rules = this.loadRolesForLocation(locationId);
    }
    if (!rules) {
      return false;
    }
    let key = action.replace(/\//g, '-').toLowerCase();
    return !!rules[`d${key}`];
  }

  @action.bound
  canEditCase(serviceTypeId: number, locationId: number) {
    if (Number(locationId) > 0) {
      return (
        this.canDoAction('/Clinical/ServiceType1/Case/{id}/Edit', locationId) &&
        this.editableServiceTypeIds.includes(serviceTypeId)
      );
    }
    return false;
  }

  @action.bound
  private loadRolesForLocation(locationId: number = -1) {
    if (!this.loaded || !locationId || locationId === -1) {
      return null;
    }
    let rules = {};
    let role = this.roles[this.roleMap[locationId]];

    if (!!role) {
      Object.entries(role).forEach((y) => {
        let [key, value] = y;
        rules[key.replace(/\//g, '-').toLowerCase()] = value;
      });
      this.map.set(locationId.toString(), rules);
    }
    return rules;
  }
}

export default PermissionsStore;
